module.exports = __webpack_public_path__ + "static/media/official_channel86540f269103c738735be300d14fa482.webp";